import actions from "@iso/redux/taskStatus/actions";

const initialState = {
  statuses: [],
  statusesByScreen: [],
  loading: false,
  loadingByScreen: false,
};

export default function taskStatusReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_STATUS_SUCCESS:
      return {
        ...state,
        statuses: action.statuses,
        loading: false,
      };
    case actions.GET_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case actions.GET_STATUS_BY_SCREEN_REQUEST:
      return {
        ...state,
        loadingByScreen: true,
      };
    case actions.GET_STATUS_BY_SCREEN_SUCCESS:
      return {
        ...state,
        statusesByScreen: action.statuses,
        loadingByScreen: false,
      };
    case actions.GET_STATUS_BY_SCREEN_ERROR:
      return {
        ...state,
        loadingByScreen: false,
        error: action.error,
      };

    default:
      return state;
  }
}
